import { BaseTabelaPDF, } from '@monorepo-web/pdf-generator';
import { getLayouts } from './layouts';
export default function TabelaFluxoResgatePDF(props) {
    const { titulo = 'Fluxo de Resgate', layout = 'default' } = props;
    const columns = getLayouts()[layout];
    return BaseTabelaPDF(Object.assign(Object.assign({}, props), { titulo,
        columns }));
}
